import { useInfiniteQuery } from "@tanstack/react-query";
import { axiosInterceptor } from "..";
import { FeedbackResponse } from "../interface";

const fetchFeedbacks = async (
  orgId: string,
  subUserId: string,
  pageParam: number = 1,
  limit: number = 10
): Promise<FeedbackResponse> => {
  const { data } = await axiosInterceptor.get(
    `feedbacks-b2b/${orgId}/${subUserId}`,
    {
      params: { page: pageParam, limit },
    }
  );
  return data;
};

const useFeedbacks = (
  orgId?: string,
  subUserId?: string,
  limit: number = 10
) => {
  return useInfiniteQuery({
    queryKey: ["feedbacks", orgId, subUserId, limit],
    queryFn: ({ pageParam = 1 }) => {
      if (!orgId || !subUserId)
        return Promise.reject("Missing orgId or subUserId");
      return fetchFeedbacks(orgId, subUserId, pageParam, limit);
    },
    getNextPageParam: (lastPage, allPages) => {
      const currentLength = allPages.flatMap((page) => page.feedbacks).length;
      const total = lastPage.total;
      return currentLength < total ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
    enabled: !!orgId && !!subUserId,
  });
};

export default useFeedbacks;
